import React from 'react'

export interface FiltersContextType<T> {
  filters: Partial<T>
  setFilters: (filters: Partial<T>, override?: boolean) => void
}

export function createFilterContext<T>() {
  const FilterContext = React.createContext<FiltersContextType<T>>({
    filters: {},
    setFilters: () => {},
  })

  const FilterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [filters, setFiltersState] = React.useState<Partial<T>>({})

    const setFilters = (newFilters: Partial<T>, override?: boolean) => { override ? setFiltersState(newFilters) : setFiltersState({ ...filters, ...newFilters }) }

    return (
      <FilterContext.Provider value={{ filters, setFilters }}>
        {children}
      </FilterContext.Provider>
    )
  }

  // Create a custom hook for using this context
  const useFilter = () => React.useContext(FilterContext)

  return { FilterProvider, useFilter }
}
